import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import { Select, Table, Button, Modal } from "antd";

import { fetchLimitsBonusesList } from "../../../redux/actions/premiumActions";

import ModalComponent from "../../../components/modalComponent/ModalComponent";
import { currentClientSelector } from "../../../redux/selectors/auth";

import ClientRegularBonusForm from "./ClientRegularBonus.form";
import UserRegularBonusForm from "./UserRegularBonus.form";

import { fetchUsers, generateRegularBonuses } from "../../../modules/presence/api/api";
import { handleError } from "../../../modules/presence/sagas";
import { FREQUENCY_ID, roles } from "../../../configs/constants";
import { selectUserRoleId } from "../../../redux/selectors/user";
const Help = () => {
  const [isVisible, setIsVisible] = useState(false);
  return (
    <React.Fragment>
      <Button type="primary" onClick={() => setIsVisible(true)}>
        Information
      </Button>
      <Modal
        title="Liste des primes normales"
        visible={isVisible}
        onOk={() => setIsVisible(false)}
        onCancel={() => setIsVisible(false)}
      >
        <p style={{ marginBottom: 16 }}>
          Ecran avec un tableau permettant de visualiser les montants et plafonds trimestrielles et mensuelles par
          utilisateur
        </p>
        <p style={{ marginTop: 4 }}> Actions possibles </p>
        <p style={{ marginTop: 4, marginLeft: 10 }}>
          Manager/Directeur : modification du montant des primes normales mensuelles/trimestrielles pour le dossier
          (doivent être inférieurs aux plafonds)
        </p>
        <p style={{ marginTop: 4, marginLeft: 10 }}>
          Manager/Directeur : modification du montant des primes normales mensuelles/trimestrielles pour un utilisateur
          (doivent être inférieurs aux plafonds)
        </p>
        <p style={{ marginTop: 4, marginLeft: 10 }}>Manager/Directeur : bouton pour générer les primes mensuelles</p>
        <p style={{ marginTop: 4, marginLeft: 10 }}>
          Manager/Directeur : bouton pour générer les primes trimestrielles
        </p>
      </Modal>
    </React.Fragment>
  );
};
const GenerateButton = ({ frequency_id, token, fetchLimits, client_id }) => {
  return (
    <div className="mr-20">
      <div
        className="cursor-pointer px-6 py-2 leading-5 rounded-full bg-gray-800 text-white"
        onClick={async () => {
          try {
            const { ok, message } = await generateRegularBonuses({ token, frequency_id, client_id });
            fetchLimits();
            Modal.confirm({ title: ok ? "Succés" : "Echec", content: message });
          } catch (e) {
            handleError(e);
          }
        }}
      >
        {`Générer les primes ${frequency_id === FREQUENCY_ID.MONTHLY ? "mensuelles" : "trimestrielles"}`}
      </div>
    </div>
  );
};
const RegularBonuses = ({ limitsBonusesList = [], getLimitsBonusesList, client = {}, token, roleId }) => {
  const [isClientFormOpen, setIsClientFormOpen] = useState(false);
  const [isUserFormOpen, setIsUserFormOpen] = useState(false);
  const [userEmail, setUserEmail] = useState();
  const [users, setUsers] = useState([]);
  const initUsers = async () => {
    try {
      const response = await fetchUsers(
        {
          match: { "clients.id": client.id },
          sort: { email: 1 },
          project: { email: 1 }
        },
        token
      );
      if (Array.isArray(response)) {
        setUsers(response);
      }
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    initUsers();
    getLimitsBonusesList();
  }, [client.id]);

  const columns = [
    {
      title: "Utilisateur",
      dataIndex: "user_email",
      key: "user_email",
      defaultSortOrder: "ascend",
      sorter: (a, b) => a.user_email.localeCompare(b.user_email)
    },
    {
      title: "Prime mensuelle",
      dataIndex: "monthly_amount",
      key: "monthly_amount"
    },
    {
      title: "Plafond mensuel",
      dataIndex: "monthly_limit",
      key: "limit"
    },
    {
      title: "Prime trimestrielle",
      dataIndex: "quarterly_amount",
      key: "quarterly_amount"
    },

    {
      title: "Plafond trimestriel",
      dataIndex: "quarterly_limit",
      key: "quarterly_limit"
    },
    {
      title: "Montant Défini par",
      dataIndex: "amount_set_by.user_email",
      key: "amount_set_by.user_email"
    },
    {
      title: "Plafond défini par",
      dataIndex: "limit_set_by.user_email",
      key: "limit_set_by.user_email"
    },

    {
      title: "Actions",
      dataIndex: "user_email",
      key: "user_id",
      render: user_email => (
        <a
          className="flex mt-2 cursor-pointer underline font-bold text-orange-400"
          onClick={() => {
            setUserEmail(user_email);
            setIsUserFormOpen(true);
          }}
        >
          Modifier
        </a>
      )
    }
  ];
  const selectedUser = users.find(user => user.email === userEmail) || {};
  const selectedUserId = selectedUser._id;

  return (
    <div className="w-full">
      <div className="flex justify-between mb-5">
        <div className="flex items-center">
          <div className="text-3xl font-bold text-gray-900">Gestion des primes normales de {client.label}</div>
        </div>
        <Help />
        {roleId <= roles.MANAGER && (
          <GenerateButton
            frequency_id={FREQUENCY_ID.MONTHLY}
            token={token}
            cliend_id={client.id}
            fetchLimits={getLimitsBonusesList}
          />
        )}
        {roleId <= roles.MANAGER && (
          <GenerateButton
            frequency_id={FREQUENCY_ID.QUARTERLY}
            token={token}
            cliend_id={client.id}
            fetchLimits={getLimitsBonusesList}
          />
        )}
      </div>

      <div className="flex justify-between m-5 items-center">
        <div className="flex items-center">
          <div className="m-5">Choisir un utilisateur</div>
          <Select
            allowClear
            showSearch
            placeholder={"Choisir un utilisateur"}
            onChange={setUserEmail}
            value={userEmail}
            style={{ minWidth: 150 }}
          >
            {users.map(item => (
              <Select.Option key={item._id} value={item.email}>
                {item.email}
              </Select.Option>
            ))}
          </Select>
          {userEmail && (
            <div
              className="cursor-pointer m-5 px-6 py-2 leading-5 rounded-full bg-gray-800 text-white text-center"
              onClick={() => setIsUserFormOpen(true)}
            >
              Définir les montants
            </div>
          )}
        </div>
        <div
          className="cursor-pointer px-6 py-2 leading-5 rounded-full bg-gray-800 text-white text-center"
          onClick={() => setIsClientFormOpen(true)}
        >
          Modifier au niveau du dossier {client.label}
        </div>
      </div>
      <ModalComponent
        title={`Modification montants primes pour l'utilisateur`}
        width={500}
        showModal={isUserFormOpen}
        closeModal={() => setIsUserFormOpen(false)}
      >
        <UserRegularBonusForm
          key={userEmail}
          getLimitsBonusesList={getLimitsBonusesList}
          user_id={selectedUserId}
          closeModal={() => setIsUserFormOpen(false)}
        />
      </ModalComponent>
      <ModalComponent
        title={`Modification montants primes pour du dossier`}
        width={500}
        showModal={isClientFormOpen}
        closeModal={() => setIsClientFormOpen(false)}
      >
        <ClientRegularBonusForm
          getLimitsBonusesList={getLimitsBonusesList}
          closeModal={() => setIsClientFormOpen(false)}
        />
      </ModalComponent>
      <Table rowKey="_id" columns={columns} dataSource={limitsBonusesList} pagination={false} />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    roleId: selectUserRoleId(state),
    client: currentClientSelector(state),
    limitsBonusesList: state.premium.bonusesLimitsList,
    token: state.auth.token
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getLimitsBonusesList: () => dispatch(fetchLimitsBonusesList())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RegularBonuses);



// WEBPACK FOOTER //
// src/containers/admin/premium/RegularBonuses.js